export default "__VITE_ASSET__BhWqFtcT__"